<template>
  <div class="container print-resident-account">
    <ErrorsMessages :errors="errors" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">
          LANÇAMENTO NÃO ENCONTRADO!
        </h6>
      </div>
      <div v-if="data.length > 0">
        <div class="mb-5 content-btn-print d-flex justify-content-end">
          <v-btn class="btn-print" @click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table class="bg-white">
          <thead>
            <div class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-1 pb-0">
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 pt-1 pb-0">
                <div v-if="resident" class="row">
                  <img
                    v-if="resident.photo_url"
                    class="resident_photo_url"
                    :src="resident.photo_url"
                  />
                  <img
                    v-if="!resident.photo_url"
                    class="resident_photo_url"
                    :src="require('../../../assets/user.png')"
                  />
                  <div class="ml-5 mt-2">
                    <h6 class="mb-0">
                      {{ resident.name }}
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de nascimento:
                      {{ formatDate(resident.date_of_birth, false) }}
                      -
                      {{ getAge(resident.date_of_birth) }}
                      anos
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de admissão:
                      {{ formatDate(resident.date_of_reception, false) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pt-1 pb-0 check-text-right"
              >
                <img class="logo" :src="logo" width="180" />
              </div>
            </div>
          </thead>
          <div class="data-inside-avoid">
            <div class="text-center">
              <h6 class="m-0">INFORMAÇÕES</h6>
            </div>
            <div
              v-if="
                (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
                movement != 'ENTRADA'
              "
              class="row m-0"
            >
              <div class="col-md-4 pt-0 pb-0">
                <small>Conta</small>
                <p class="m-0">
                  {{ data[0].finance_configuration_account_name }}
                </p>
              </div>
              <div class="col-md-4 pt-0 pb-0">
                <small>Competência</small>
                <p class="m-0">
                  {{ moment(data[0].competence).format("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="col-md-4 pt-0 pb-0 text-right">
                <small>Vencimento</small>
                <p class="m-0">
                  {{ moment(data[0].due_date).format("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
                <small class="mr-2">Criado em:</small>
                <p class="m-0 mr-2">
                  {{ moment(data[0].created_at).format("DD/MM/YYYY HH:mm:ss") }}
                </p>
                <small class="mr-2">por:</small>
                <p class="m-0">
                  {{
                    professionalClassCouncilValue({
                      id: data[0].user_professional_class_council_id,
                      name: data[0].user_name,
                      profile: data[0].user_profile_name,
                      cpf: data[0].user_cpf,
                      office: data[0].user_office,
                      value: data[0].user_professional_class_council_value,
                    })
                  }}
                </p>
              </div>
            </div>
            <div class="mt-5">
              <v-data-table
                class="v-data-table-no-border v-data-table-finance"
                :headers="headers"
                :items="data"
                item-key="_id"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.date`]="{ item }">
                  <div class="d-flex align-items-center">
                    <div class="text-twelve">
                      {{
                        (type == "PRODUTO" || type == "MEDICAMENTO") &&
                        movement == "ENTRADA"
                          ? "--"
                          : item.date
                      }}
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.paid_in_date`]="{ item }">
                  <div class="text-twelve">
                    {{
                      (type == "PRODUTO" || type == "MEDICAMENTO") &&
                      movement == "ENTRADA"
                        ? "--"
                        : item.is_paid == 1
                        ? item.paid_in_date
                        : "--"
                    }}
                  </div>
                </template>
                <template v-slot:[`item.categories`]="{ item }">
                  <div
                    v-if="
                      (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
                      movement != 'ENTRADA'
                    "
                    class="text-right"
                  >
                    <p
                      :style="`background-color: ${
                        item.finance_configuration_category_color
                          ? item.finance_configuration_category_color
                          : '#999'
                      }`"
                      :class="[
                        'pl-1 pr-1 m-0 limit-text worksansr text-twelve',
                        String(
                          item.finance_configuration_category_color
                        ).toUpperCase() == '#FFFFFF'
                          ? ''
                          : 'c-white',
                      ]"
                    >
                      {{ item.finance_configuration_category_name }}
                    </p>
                  </div>
                  <span
                    v-if="
                      (type == 'PRODUTO' || type == 'MEDICAMENTO') &&
                      movement == 'ENTRADA'
                    "
                    >--</span
                  >
                </template>
                <template v-slot:[`item.description`]="{ item }">
                  <div
                    v-if="
                      (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
                      movement != 'ENTRADA'
                    "
                  >
                    <small>Descrição</small>
                    <p class="m-0">{{ item.description }}</p>
                  </div>
                  <div
                    v-if="
                      (type == 'PRODUTO' || type == 'MEDICAMENTO') &&
                      movement == 'ENTRADA'
                    "
                  >
                    <div v-if="item.entity" class="row">
                      <div class="col-md-12 pt-0 pb-0 border-bottom">
                        <small>{{ type }}:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.medicine_product_name
                          }}</strong></small
                        >
                      </div>
                      <div class="col-md-6 pt-0 pb-0 border-bottom">
                        <small>GRUPO:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.stock_group_name
                          }}</strong></small
                        >
                      </div>
                      <div class="col-md-6 pt-0 pb-0 border-bottom">
                        <small>QUANTIDADE:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.amount
                          }}</strong></small
                        >
                      </div>
                      <div class="col-md-6 pt-0 pb-0 border-bottom">
                        <small>LOTE:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.lot
                          }}</strong></small
                        >
                      </div>
                      <div class="col-md-6 pt-0 pb-0 border-bottom">
                        <small>ENTRADA:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.entry_date
                          }}</strong></small
                        >
                      </div>
                      <div class="col-md-6 pt-0 pb-0 border-bottom">
                        <small>VENCIMENTO:</small>
                        <small
                          ><strong class="ml-2">{{
                            item.entity.due_date
                          }}</strong></small
                        >
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.value`]="{ item }">
                  <div
                    v-if="
                      (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
                      movement != 'ENTRADA'
                    "
                    style="min-width: 100px !important"
                    :class="[`c-${item.color}`, 'text-right']"
                  >
                    {{ item.color == "danger" ? "-" : "" }}
                    {{ formatMoney(String(item.value).replace("-", "")) }}
                  </div>
                  <div
                    v-if="
                      (type == 'PRODUTO' || type == 'MEDICAMENTO') &&
                      movement == 'ENTRADA'
                    "
                    style="min-width: 100px !important"
                    class="c-success text-right"
                  >
                    {{ formatMoney(String(0)) }}
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div
                    v-if="
                      (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
                      movement != 'ENTRADA'
                    "
                    class="text-right"
                  >
                    <v-btn
                      :class="[
                        'p-2',
                        !item.late_payment && 'btn-edit',
                        item.late_payment && 'btn-i',
                      ]"
                      x-small
                      v-if="item.is_paid == 0"
                    >
                      <i class="fas fa-clock mr-1"></i>
                      PAGAR
                    </v-btn>
                    <v-btn
                      class="p-2 btn-save"
                      x-small
                      v-if="item.is_paid == 1"
                    >
                      <i class="fas fa-check mr-1"></i>PAGO
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      (type == 'PRODUTO' || type == 'MEDICAMENTO') &&
                      movement == 'ENTRADA'
                    "
                    class="text-right"
                  >
                    FAMÍLIA
                  </div>
                </template>
              </v-data-table>
            </div>
            <div class="d-flex align-items-end justify-content-end">
              <h4 class="m-0 mr-2">TOTAL:</h4>
              <h4 class="c-success m-0">
                {{ formatMoney(String(totalValue)) }}
              </h4>
            </div>
          </div>
          <div class="text-center mt-5">
            (Assinatura eletrônica)
            {{
              professionalClassCouncilValue({
                id: user.professional_class_council_id,
                name: user.name,
                profile: user.profile_name,
                cpf: user.cpf,
                office: user.office,
                value: user.professional_class_council_value,
              })
            }}
            <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
          </div>
        </table>
        <div class="mt-5 content-btn-print d-flex justify-content-end">
          <v-btn class="btn-print" @click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import routes from "../../../routes";

import { userData } from "../../../lib/functions";

import { getAge } from "../../../lib/getAgeByDate";

import {
  formatDate,
  formatMoney,
  professionalClassCouncilValue,
} from "../../../lib/format";

import moment from "moment";

export default {
  name: "ResidentAccountPrint",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      loading: false,

      resident_id: "",
      id: "",
      type: "",
      origin: "",
      movement: "",

      errors: [],

      data: [],
      resident: null,

      options: {
        page: 1,
      },

      headers: [
        { text: "VENCIMENTO", value: "date", sortable: false },
        { text: "PAGO", value: "paid_in_date", sortable: false },
        { text: "CATEGORIA", value: "categories", sortable: false },
        { text: "Descrição", value: "description", sortable: false },
        { text: "VALOR", value: "value", sortable: false, align: "end" },
        { text: "STATUS", value: "status", sortable: false, align: "end" },
      ],

      totalValue: 0,

      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    getAge,
    formatDate,
    formatMoney,
    professionalClassCouncilValue,

    retrieve() {
      const { resident_id, type, origin, movement, id } =
        routes.history.current.params;

      if (!resident_id || !type || !id) {
        this.errors = ["Lançamento não encontrado"];
        return;
      }

      this.resident_id = resident_id;
      this.type = type;
      this.origin = origin;
      this.movement = movement;
      this.id = id;

      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { resident_id, type, origin, movement, id } = this;

        let params = { resident_id, type, origin, movement, id };

        const response = await api.get("/rest-home/resident/account/print", {
          params,
        });

        const { data, resident, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let totalValue = 0;
          for (let item of data) {
            if (item.total) {
              totalValue = parseFloat(totalValue) + parseFloat(item.total);
            }
          }
          this.data = data;
          this.resident = resident;
          this.totalValue = totalValue;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut() {
      window.print();
    },
  },
};
</script>

<style>
.print-resident-account table {
  width: 100%;
}

.print-resident-account .logo {
  height: 50px;
  object-fit: contain;
}

.print-resident-account .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-resident-account .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  .print-resident-account table {
    width: 100% !important;
  }

  .print-resident-account button {
    display: none;
  }

  .print-resident-account .data-inside-avoid {
    page-break-inside: avoid !important;
  }
}
</style>
